import { useAppStore } from '@/modules/app/store/useAppStore';
import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';

import { useCopyPasteStore } from '../store/useCopyPasteStore';
import { CopyPasteServiceImpl } from './CopyPasteServiceImpl';
import { ICopyPasteService } from './ICopyPasteService';
import { CopyPasteServiceLogDecorator } from './CopyPasteServiceLogDecorator';

export class CopyPasteServiceFactory {
  private static instance: CopyPasteServiceFactory | null = null;
  private copyPasteStore: typeof useCopyPasteStore;
  private appStore: typeof useAppStore;
  private floorplanDesignStore: typeof useFloorplanDesignStore;

  public static initialize(
    copyPasteStore: typeof useCopyPasteStore,
    appStore: typeof useAppStore,
    floorplanDesignStore: typeof useFloorplanDesignStore,
  ) {
    CopyPasteServiceFactory.instance = new CopyPasteServiceFactory(
      copyPasteStore,
      appStore,
      floorplanDesignStore,
    );
  }

  public static getInstance() {
    if (CopyPasteServiceFactory.instance === null) {
      throw new Error(
        'CopyPasteServiceFactory not yet initialized. Call CopyPasteServiceFactory.initialize() first.',
      );
    }
    return CopyPasteServiceFactory.instance;
  }

  private constructor(
    copyPasteStore: typeof useCopyPasteStore,
    appStore: typeof useAppStore,
    floorplanDesignStore: typeof useFloorplanDesignStore,
  ) {
    this.copyPasteStore = copyPasteStore;
    this.appStore = appStore;
    this.floorplanDesignStore = floorplanDesignStore;
  }

  public createService(): ICopyPasteService {
    let result: ICopyPasteService = this.makeService();

    result = new CopyPasteServiceLogDecorator(result);

    return result;
  }

  private makeService(): ICopyPasteService {
    return new CopyPasteServiceImpl(this.copyPasteStore, this.appStore, this.floorplanDesignStore);
  }
}
